import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=580a8044&scoped=true"
import script from "./Target.vue?vue&type=script&lang=js"
export * from "./Target.vue?vue&type=script&lang=js"
import style0 from "./Target.vue?vue&type=style&index=0&id=580a8044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a8044",
  null
  
)

export default component.exports